export default "__VITE_ASSET__DOLdZlHy__"